import { Link } from "react-router-dom";

const LinkStudent = () => {
  return (
    <div className="p-6 max-w-xl mx-auto text-center space-y-4">
      <h2 className="text-xl font-semibold">Linking has moved</h2>
      <p className="text-sm text-muted-foreground">
        Profile linking now happens directly inside the chat experience. Please return to the home
        page to continue.
      </p>
      <Link
        to="/"
        className="inline-block bg-primary text-primary-foreground px-6 py-3 rounded-lg text-sm hover:bg-primary/90 transition-colors"
      >
        Go to Home
      </Link>
    </div>
  );
};

export default LinkStudent;
